import { dsv2, dsv2Light } from '../styles/designSystemV2';
import { useThemeColors } from '../context/ThemeContext';

export default function AmbientFX() {
  const { isDark } = useThemeColors();
  const tokens = isDark ? dsv2 : dsv2Light;
  return (
    <>
      <div style={{
        position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0,
        backgroundImage: tokens.neonGrid, opacity: 0.8,
      }} />
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
        <div style={{
          position: 'absolute', top: '12%', right: '6%',
          width: 620, height: 620, background: tokens.fx.redBlob, filter: 'blur(60px)',
        }} />
        <div style={{
          position: 'absolute', bottom: '4%', left: '12%',
          width: 480, height: 480, background: tokens.fx.blueBlob, filter: 'blur(50px)',
        }} />
      </div>
    </>
  );
}
